enum Grade {
  FULLY_DISAGREE = 'FULLY_DISAGREE',
  GENERALLY_DISAGREE = 'GENERALLY_DISAGREE',
  CANT_DECIDE = 'CANT_DECIDE',
  GENERALLY_AGREE = 'GENERALLY_AGREE',
  FULLY_AGREE = 'FULLY_AGREE',
}

export { Grade };
